import CrossSectionIcon from "@/assets/icons/CrossSection.module.svg";
import type { SvgComponentProps } from "@/style/img/MapSvg";
import type React from "react";

const CrossSectionSvg: React.FunctionComponent<SvgComponentProps> = () => <CrossSectionIcon />;

export default CrossSectionSvg;
